module.exports = __webpack_public_path__ + "img/choose.250d4447.svg";